import { useEffect, useRef } from 'react';

export function useFaviconBadge(unreadCount: number) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) return;

    // The clean (un-badged) favicon. `useFavicon` keeps `data-base-href`
    // pointed at the resolved favicon; fall back to the current href before
    // that effect has run.
    const baseHref = link.dataset.baseHref || link.href;

    if (unreadCount === 0) {
      link.href = baseHref;
      return;
    }

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      if (!canvasRef.current) {
        canvasRef.current = document.createElement('canvas');
      }
      const canvas = canvasRef.current;
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);

      // Draw red dot in top-right corner
      const dotRadius = Math.max(4, canvas.width * 0.2);
      ctx.beginPath();
      ctx.arc(canvas.width - dotRadius, dotRadius, dotRadius, 0, 2 * Math.PI);
      ctx.fillStyle = '#ef4444';
      ctx.fill();

      link.href = canvas.toDataURL('image/png');
    };
    img.src = baseHref;

    return () => {
      link.href = baseHref;
    };
  }, [unreadCount]);
}
